import { lazy } from 'react';
import {
    EditOutlined,
    FormOutlined,
    AuditOutlined,
    SettingOutlined,
    HomeOutlined,
    FileSearchOutlined,
} from '@ant-design/icons';
import UserNotice from 'pages/userApply/notice';
import ApplyInfo from 'pages/applyInfo';
import Assessment from 'pages/userApply/assessment';
import ApplyList from 'pages/applyList';
import NoticeEdit from 'pages/noticeEdit';
import NursingBedMGT from 'pages/nursingBedMGT';
import MenuMGT from 'pages/systemMGT/menuMGT';
import UserMGT from 'pages/systemMGT/userMGT';
import AdminMGT from 'pages/systemMGT/adminMGT';
import RoleMGT from 'pages/systemMGT/roleMGT';
import ApiMGT from 'pages/systemMGT/apiMGT';
import SystemConfig from 'pages/systemMGT/config';
import VisitRecord from 'pages/visitAndCheckIn/visitRecord';
import CheckInRecord from 'pages/visitAndCheckIn/checkInRecord';
import CheckOutRecord from 'pages/visitAndCheckIn/checkOutRecord';
import CheckInChange from 'pages/visitAndCheckIn/checkInChange';
import readNoticeRecord from 'pages/readNoticeRecord';
import TimeStatistics from '../pages/statistics/timeStatistics';
import CheckStatistics from '../pages/statistics/checkStatistics';
import CheckIdenStatistics from '../pages/statistics/checkIdenStatistics';
import CheckOutStatistics from '../pages/statistics/checkOutStatistics';
import ChangeStatistics from '../pages/statistics/changeStatistics';
import ConditionStatistics from '../pages/statistics/conditionStatistics';
import ApiLog from '../pages/systemMGT/apiLog';
import Dashboard from '../pages/dashboard';

const VisitorApply = lazy(() => import('../pages/visitorApply'));
const VisitorApplyIndex = lazy(() => import('../pages/visitorApplyIndex'));
const VisitorApplyLogin = lazy(() => import('../pages/visitorApplyLogin'));
const VisitorApplySuccess = lazy(() => import('../pages/visitorApply/success'));
const VisitorApplyList = lazy(() => import(`../pages/visitorApplyList`));
const Login = lazy(() => import('../pages/login'));
const AdminLogin = lazy(() => import('../pages/login'));

/** 路由配置项 routerListItem
 * @param path 路由路径 required
 * @param name 路由名称 required
 * @param key 路由key required
 * @param exact 精确匹配
 * @param notAuth 无需登录
 * @param component 对应组件
 * @param hide 菜单隐藏 required
 */
const routerList = () => {
    let routers = [
        {
            path: '/visitorApply',
            key: 'visitorApply',
            name: '访客登记',
            exact: true,
            notAuth: true,
            component: VisitorApply,
        },
        {
            path: '/visitorApplyLogin',
            key: 'visitorApplyLogin',
            name: '探访登录',
            exact: true,
            notAuth: true,
            component: VisitorApplyLogin,
        },
        {
            path: '/visitorApplyList',
            key: 'visitorApplyList',
            name: '历史列表',
            exact: true,
            notAuth: true,
            component: VisitorApplyList,
        },
        {
            path: '/visitorApplyIndex',
            key: 'visitorApplyIndex',
            name: '探访入口',
            exact: true,
            notAuth: true,
            component: VisitorApplyIndex,
        },
        {
            path: '/visitorApply/success',
            key: 'visitorApply_success',
            name: '访客登记成功',
            exact: true,
            notAuth: true,
            component: VisitorApplySuccess,
        },
        {
            path: '/login',
            key: 'login',
            name: '登录页',
            exact: true,
            notAuth: true,
            component: Login,
        },
        {
            path: '/login',
            key: 'login',
            name: '注册页',
            exact: true,
            notAuth: true,
            component: Login,
        },
        {
            path: '/adminLogin',
            key: 'adminLogin',
            name: '管理员登录页',
            exact: true,
            notAuth: true,
            component: AdminLogin,
        },
        {
            path: '/404',
            key: '404',
            name: '404页面',
            exact: true,
            notAuth: true,
            component: lazy(() => import('../pages/404')),
        },
        {
            path: '/dashboard',
            key: 'dashboard',
            name: '工作台',
            exact: true,
            component: Dashboard,
            icon: <HomeOutlined />,
        },
        {
            path: '/userApply',
            key: 'userApply',
            name: '轮候申请',
            icon: <EditOutlined />,
            exact: true,
            routes: [
                {
                    path: '/userApply/notice',
                    key: 'userApply_notice',
                    name: '入住须知',
                    exact: true,
                    component: UserNotice,
                    hide: true,
                },
                {
                    path: '/userApply/fillInBaseInfo',
                    key: 'userApply_fillInBaseInfo',
                    name: '填写申请',
                    exact: true,
                    component: ApplyInfo,
                    hide: true,
                },
                {
                    path: '/userApply/assessment',
                    key: 'userApply_assessment',
                    name: '申请人评估',
                    exact: true,
                    component: Assessment,
                    hide: true,
                },
            ],
        },
        {
            path: '/noticeEdit',
            key: 'noticeEdit',
            name: '通知编辑',
            component: NoticeEdit,
            exact: true,
            icon: <FormOutlined />,
        },
        {
            path: '/applySelfProgress',
            key: 'applySelfProgress',
            name: '进度查询',
            exact: true,
            component: ApplyList,
            icon: <FileSearchOutlined />,
            routes: [
                {
                    path: '/applySelfProgress/applyEdit/:id',
                    key: 'applySelfProgress_applyEdit',
                    name: '申请变更',
                    component: ApplyInfo,
                    exact: true,
                    icon: <FormOutlined />,
                    hide: true,
                },
                {
                    path: '/applySelfProgress/applyDetail/:id',
                    key: 'applySelfProgress_applyDetail',
                    name: '申请详情',
                    component: ApplyInfo,
                    hide: true,
                },
            ],
        },
        {
            path: '/applyProgress',
            key: 'applyProgress',
            name: '进度查询',
            exact: true,
            component: ApplyList,
            icon: <FileSearchOutlined />,
            routes: [
                {
                    path: '/applyProgress/applyDetail/:id',
                    key: 'applyProgress_applyDetail',
                    name: '申请详情',
                    component: ApplyInfo,
                    hide: true,
                },
            ],
        },
        {
            path: '/applyReview',
            key: 'applyReview',
            name: '复核审批',
            exact: true,
            component: ApplyList,
            icon: <AuditOutlined />,
        },
        {
            path: '/applyApproval',
            key: 'applyApproval',
            name: '轮候审批',
            exact: true,
            component: ApplyList,
            icon: <AuditOutlined />,
        },
        {
            path: '/applyEvaluate',
            key: 'applyEvaluate',
            name: '院前评估审批',
            exact: true,
            component: ApplyList,
            icon: <AuditOutlined />,
        },
        {
            path: '/applyAdmission',
            key: 'applyAdmission',
            name: '入院审批',
            exact: true,
            component: ApplyList,
            icon: <AuditOutlined />,
        },
        {
            path: '/systemMGT',
            key: 'systemMGT',
            name: '系统管理',
            exact: true,
            icon: <SettingOutlined />,
            routes: [
                {
                    path: '/systemMGT/userMGT',
                    key: 'systemMGT_userMGT',
                    name: '用户管理',
                    exact: true,
                    component: UserMGT,
                },
                {
                    path: '/systemMGT/adminMGT',
                    key: 'systemMGT_adminMGT',
                    name: '管理员中心',
                    exact: true,
                    component: AdminMGT,
                },
                {
                    path: '/systemMGT/roleMGT',
                    key: 'systemMGT_roleMGT',
                    name: '角色管理',
                    exact: true,
                    component: RoleMGT,
                },
                {
                    path: '/systemMGT/menuMGT',
                    key: 'systemMGT_menuMGT',
                    name: '菜单管理',
                    exact: true,
                    component: MenuMGT,
                },
                {
                    path: '/systemMGT/apiMGT',
                    key: 'systemMGT_apiMGT',
                    name: '接口管理',
                    exact: true,
                    component: ApiMGT,
                },
                {
                    path: '/systemMGT/config',
                    key: 'systemMGT_config',
                    name: '系统配置',
                    exact: true,
                    component: SystemConfig,
                },
                {
                    path: '/systemMGT/apiLog',
                    key: 'api_log',
                    name: '操作记录',
                    exact: true,
                    component: ApiLog,
                },
            ],
        },
        {
            path: '/nursingBedMGT',
            key: 'nursingBedMGT',
            name: '床位管理',
            exact: true,
            component: NursingBedMGT,
            icon: <SettingOutlined />,
        },
        {
            path: '/readNoticeRecord',
            key: 'readNoticeRecord',
            name: '阅读通知记录',
            exact: true,
            component: readNoticeRecord,
            icon: <SettingOutlined />,
        },
        {
            path: '/visitAndCheckIn',
            key: 'visitAndCheckIn',
            name: '来访入住',
            exact: true,
            icon: <HomeOutlined />,
            routes: [
                {
                    path: '/visitAndCheckIn/visitRecord',
                    key: 'visitAndCheckIn_visitRecord',
                    name: '来访申请记录',
                    exact: true,
                    component: VisitRecord,
                },
                {
                    path: '/visitAndCheckIn/checkInRecord',
                    key: 'visitAndCheckIn_checkInRecord',
                    name: '入住记录',
                    exact: true,
                    component: CheckInRecord,
                },
                {
                    path: '/visitAndCheckIn/checkInChange',
                    key: 'visitAndCheckIn_checkInChange',
                    name: '入住变更记录',
                    exact: true,
                    component: CheckInChange,
                },
            ],
        },
        {
            path: '/statistics',
            key: 'statistics',
            name: '统计报表',
            exact: true,
            icon: <AuditOutlined />,
            routes: [
                {
                    path: '/statistics/timeStatistics',
                    key: 'Statistics_TimeStatistics',
                    name: '申请统计',
                    exact: true,
                    component: TimeStatistics,
                },
                {
                    path: '/statistics/checkInStatistics',
                    key: 'Statistics_CheckStatistics',
                    name: '在院统计',
                    exact: true,
                    component: CheckStatistics,
                },
                {
                    path: '/statistics/checkInOutStatistics',
                    key: 'Statistics_CheckOutStatistics',
                    name: '出院统计',
                    exact: true,
                    component: CheckOutStatistics,
                },
                {
                    path: '/statistics/checkIdenStatistics',
                    key: 'Statistics_CheckIdenStatistics',
                    name: '身份统计',
                    exact: true,
                    component: CheckIdenStatistics,
                },
                {
                    path: '/statistics/changeStatistics',
                    key: 'Statistics_ChangeStatistics',
                    name: '区域变更统计',
                    exact: true,
                    component: ChangeStatistics,
                },
                {
                    path: '/statistics/conditionStatistics',
                    key: 'Statistics_ConditionStatistics',
                    name: '条件统计',
                    exact: true,
                    component: ConditionStatistics,
                },
                {
                    path: '/visitAndCheckIn/checkOutRecord',
                    key: 'visitAndCheckIn_checkOutRecord',
                    name: '出院清单',
                    exact: true,
                    component: CheckOutRecord,
                },
            ],
        },
    ];
    const menuArr = (sessionStorage.getItem('menus') || '').split(',');
    routers = routers.filter(router => {
        let hasMenu = false;
        menuArr.forEach(item => {
            if ((router.key || '').includes(item)) {
                hasMenu = true;
            }
        });
        // TODO:该逻辑待确认 Dashboard 工作台始终可访问
        return router.notAuth || hasMenu || router.key === 'dashboard';
    });
    return routers;
};
export default routerList;
